<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <div class="container-wrap overflow-hidden relative" :style="{ background: sectionBackgroundColor ? sectionBackgroundColor.hex : 'transparent' }">    
    <div class="grid grid-cols-1 md:grid-cols-12 gap-0 container-wrap relative">
      <div class="col-span-12 w-full items-center flex flex-col">
        <div class="xxl:max-w-[720px] xxl:my-[128px]
        xl:w-[720px] xl:my-[128px]
        lg:w-[720px] lg:my-[128px]
        md:w-[640px] md:my-[128px] md:mx-[0px]
         mt-[48px] mb-[64px] mx-[16px]">
          <h3 class="text-[24px] font-medium leading-[31px] pb-[16px] border-b-[1px] border-[#E1E2E0]">{{ title }}</h3>
          <div class="mt-[24px] grid rows gap-[32px]">
            <article
              v-for="(article, index) in getArticles"
              :key="index"
              class="w-full"
            >
              <h3 class="w-full flex leading-130%">
                <MajorityUiMajorityLink
                  :to="$mRouter.getLocalRoute({name: 'help-article-slug', params: { slug: article.slug }})"
                  tracking-name="popularArticleButton"
                  class="underline flex flex-rows items-stretch w-full"
                  :title="article.title"
                  :aria-label="article.title"
                >
                {{ article.title }}
              </MajorityUiMajorityLink>
              <MajorityUiMajorityLink
                :to="$mRouter.getLocalRoute({name: 'help-article-slug', params: { slug: article.slug }})"
                tracking-name="popularArticleButton"
                class="flex flex-rows items-center pl-2"
                :title="article.title"
                :aria-label="article.title"
              >
                <MajorityUiMajorityIcon :alt="article.title" icon="arrow-right" class="align-right" />
              </MajorityUiMajorityLink>
              </h3>
            </article>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isNullOrUndefined } from '@/utils/comparators'
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    sectionBackgroundColor: {
      type: Object,
      default: () => {
        return {
          hex: '#FFFFFF'
        }
      }
    },
    articles: {
      type: Array,
      required: true,
      validator: val => val.every(x => !isNullOrUndefined(x.slug) && !isNullOrUndefined(x.title))
    },
    limit: {
      type: Number,
      default: () => 0
    },
    random: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {
    getArticles () {
      let articles = [...this.articles]
      if (this.random) {
        articles = articles.sort(() => Math.random() - Math.random())
      }

      if (this.limit === 0) {
        return articles
      }

      return articles.slice(0, this.limit)
    }
  }
}
</script>
<style lang="postcss" scoped>
</style>
